export enum TAB_GALLERY {
  PHOTO = 'photo',
  VIDEO = 'video',
}
